export default "__VITE_ASSET__DSp3kIKp__"